export default __webpack_public_path__ + "static/media/photo--lg--freshbooks.0dccc732.jpg";